import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/CommonOptions';

const OptionReducer = handleActions({
    [Actions.GetListOptionsRequested]: (state) => ({
        ...state,
        isFetching: false,
    }),
    [Actions.GetListOptionsReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        success: true,
        data: action.payload,
    }),
    [Actions.GetListOptionsReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        success: false,
        errors: action.payload.errors,
    }),
}, {
    isFetching: false,
    success: true,
    data: {},
    errors: {},
});

const getJobsReducer = handleActions({
    [Actions.GetJobsRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetJobsRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetJobsRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
}, {
    data: {},
    isFetching: false,
    errors: {},
});

const getZonesReducer = handleActions({
    [Actions.GetZonesRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetZonesRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetZonesRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearEventZone]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
}, {
    data: {},
    isFetching: false,
    errors: {},
});

const getZonesStatusReducer = handleActions({
    [Actions.GetZonesStatusRequested]: (state) => ({
        ...state,
        isFetching: true,
        success: false,
    }),
    [Actions.GetZonesStatusReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetZonesStatusFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const getOccupationReducer = handleActions({
    [Actions.GetOccupationRequest]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetOccupationReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetOccupationFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearOccupation]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
}, {
    data: {},
    isFetching: false,
    errors: {},
});

const getCategoryReducer = handleActions({
    [Actions.GetCategoryRequest]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetCategoryReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetCategoryFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    /*
    [Actions.ClearCategory]: () => ({
        data: {},
        isFetching: false,
        errors: {},
    }),
    */
}, {
    data: {},
    isFetching: false,
    errors: {},
});

export default combineReducers({
    Options: OptionReducer,
    jobs: getJobsReducer,
    zones: getZonesReducer,
    zonesStatus: getZonesStatusReducer,
    occupations: getOccupationReducer,
    category: getCategoryReducer,
});
